import type { ReactNode } from "react";
import { Badge } from "@studio";

/**
 * 지금 값 하나 + 기준(주의·위험) 막대. 추이가 아니라 "현재 상태" 를 보이는 카드라 차트 라이브러리를 쓰지 않는다 (CSS 막대, 접근성 role=meter).
 * 모양 클래스(lwi-gauge·lwi-meter)는 시안 insights.css.
 */
export function Meter({
  label,
  value,
  unit = "%",
  warning = 70,
  danger = 90,
  inverse = false,
  max = 100,
  note,
}: {
  label: string;
  value: number | null;
  unit?: string;
  warning?: number;
  danger?: number;
  /** 낮을수록 나쁨 (예: 가용률) */
  inverse?: boolean;
  /** 막대 100% 기준 */
  max?: number;
  note?: string;
}) {
  const level = value === null ? "neutral" : (inverse ? value < danger : value >= danger) ? "coral" : (inverse ? value < warning : value >= warning) ? "amber" : "teal";
  const status = value === null ? "기록 없음" : level === "coral" ? "위험" : level === "amber" ? "주의" : "정상";
  const pct = value === null ? 0 : Math.min(100, Math.max(0, (value / Math.max(max, 1)) * 100));
  return (
    <div className={`lwi-gauge tone-${level}`}>
      <div>
        <span>{label}</span>
        <Badge tone={level}>{status}</Badge>
      </div>
      <strong>
        {value === null ? "—" : value.toLocaleString("ko-KR")}
        <small>{value === null ? "" : unit}</small>
      </strong>
      <div className="lwi-meter" role={value === null ? undefined : "meter"} aria-label={label} aria-valuemin={0} aria-valuemax={max} aria-valuenow={value ?? undefined}>
        <span style={{ width: `${pct}%` }} />
      </div>
      <small>{note ?? `주의 ${warning}${unit} · 위험 ${danger}${unit}`}</small>
    </div>
  );
}

export function Meters({ children }: { children: ReactNode }) {
  return <div className="lwi-gauges">{children}</div>;
}
